/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { action } from "@ember/object";
import RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import BioExamResult from "core/models/bio-exam-result";
import BioExamResultsReceivedJournalEvent from "core/models/bio-exam-results-received-journal-event";
import BioExamObservation from "core/models/loinc";
import Patient from "core/models/patient";
import SemeiaSessionService from "core/services/session";
import { sortBy } from "core/utils/sort";
import triggerFileDownload from "core/utils/trigger-file-download";
import { ExamsByGroup, getGroupedBioExams } from "../utils/groupedBioExams";
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports
import { DS } from "ember-data";
import styles from "./index.module.css";
let BioExamResultsSummaryComponent = (_class = class BioExamResultsSummaryComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "styles", styles);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _initializerDefineProperty(this, "session", _descriptor3, this);
  }
  get bioExamResultsReceived() {
    return this.args.patient.bioExamResultsReceivedJournalEvents.sort(sortBy("occurredAt", "desc"));
  }
  get groupedBioExamObservations() {
    const sortedBioExams = this.store.peekAll("loinc")

    // @ts-expect-error the return type of this.store.peekAll provided by @types/ember-data is not correct
    .toSorted(function (bioA, bioB) {
      return bioA.rank - bioB.rank;
    });
    return getGroupedBioExams(sortedBioExams);
  }

  /**
   * Each entry in the Object represents an exam group, with a group name and a `codes` object
   * Each entry in the `codes` object represents a row of the summary table
   * The keys are the codes for the rows
   * the values are an array of BioExamResult
   */
  get resultsByExamGroups() {
    const resultsByExamGroups = new Map();
    if (!this.bioExamResultsReceived) return resultsByExamGroups;
    this.groupedBioExamObservations.forEach((group, name) => {
      if (group.size == 0) return;
      if (!resultsByExamGroups.has(name)) {
        resultsByExamGroups.set(name, new Map());
      }
      group.forEach((observations, loincChapter) => {
        const resultsByLoinc = observations.reduce((acc, obs) => {
          const code = obs.loinc;
          if (!this.bioExamResultsReceived.find(je => je.result(`LOINC-${code}`))) return acc;
          acc[code] = this.bioExamResultsReceived.map(je => this.resultWithJe(je, code));
          return acc;
        }, {});
        if (!Object.keys(resultsByLoinc).length) return;
        resultsByExamGroups.get(name).set(loincChapter, resultsByLoinc);
      });
    });
    return resultsByExamGroups;
  }
  downloadSummary() {
    const dates = [""];
    const rows = [];
    document.querySelectorAll("#bio-summary-table > thead > tr > th[data-test-column]").forEach(thElement => {
      dates.push(thElement.innerText.split("\n")[0]);
    });
    rows.push(dates);
    let group = "";
    document.querySelectorAll("table > tbody > tr").forEach(trElement => {
      const rowContent = [];
      // Get the LOINC group value from the tr element
      if (trElement.attributes.getNamedItem("data-test-group")) {
        group = trElement.attributes.getNamedItem("data-test-group").value;
      }
      // Get the LOINC chapter from the tr element
      if (trElement.attributes.getNamedItem("data-test-loinc-chapter-row")) {
        let loincChapter = trElement.children[0].innerText.trim();

        // Append the LOINC group to the LOINC Chapter
        switch (group) {
          // Ex : Hématologie sanguine
          case "blood":
            loincChapter += " sanguine";
            break;
          // Ex : Biochimie urinaire
          case "urinary":
            loincChapter += " urinaire";
            break;
          // Ex : Autres réultats - Fertilité
          default:
            loincChapter = `Autres résultats - ${loincChapter}`;
        }
        rowContent.push(loincChapter);
      }
      // Get the result value & unit from the tr element
      if (trElement.attributes.getNamedItem("data-test-results-row")) {
        const children = trElement.children;
        for (let i = 0; i < children.length; i++) {
          const child = children.item(i);
          rowContent.push(child.innerText.replace("\n", " ").trim());
        }
      }
      if (rowContent.length) rows.push(rowContent);
    });
    triggerFileDownload({
      fileContent: "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n"),
      fileName: `historique_bilans_biologie_patient_${this.args.patient.fullName.replace(" ", "_")}.csv`
    });
  }
  resultWithJe(je, code) {
    const result = je.result(`LOINC-${code}`);
    if (result) {
      result.originJournalEvent = je;
    }
    return result;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "downloadSummary", [action], Object.getOwnPropertyDescriptor(_class.prototype, "downloadSummary"), _class.prototype), _class);
export { BioExamResultsSummaryComponent as default };